<template functional>
  <div class="saas-video-card">
    <nuxt-link :to="props.video.path" class="saas-video-card__thumbnail">
      <img
        :src="`https://img.youtube.com/vi/${props.video.youtube_id}/mqdefault.jpg`"
        :srcset="`https://img.youtube.com/vi/${props.video.youtube_id}/maxresdefault.jpg 2x`"
        :alt="props.video.title"
        loading="lazy"
      />
    </nuxt-link>
    <div class="saas-video-card__duration">
      Duration: {{ $options.methods.formatDuration(props.video.duration) }}
    </div>
    <nuxt-link :to="props.video.path" class="saas-video-card__title">{{
      props.video.title
    }}</nuxt-link>
    <div class="saas-video-card__description">
      {{ props.video.short_description }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoCard',
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatDuration(duration) {
      const minutes = Math.floor(duration / 60)
      const seconds = duration - minutes * 60
      let text = ''

      if (minutes > 0) {
        text += `${minutes} min `
      }

      if (seconds < 10 && seconds > 0) {
        text += `0${seconds}`
      } else {
        text += `${seconds}`
      }

      return text
    },
  },
}
</script>
